<template>
    
    <b-progress class="project-progress-bar" :max="totalCount" show-value>
        <b-progress-bar :value="closed" style="background-color:#50e292"></b-progress-bar>
        <b-progress-bar :value="done" style="background-color:#3669c7;" ></b-progress-bar>
        <b-progress-bar :value="inProgress" style="background-color:#fc8540;"></b-progress-bar>
        <b-progress-bar :value="toDo" style="background-color:#7d7d81;"></b-progress-bar>
        <b-progress-bar :value="cancelled" style="background-color:rgb(170, 170, 170);"></b-progress-bar>
    </b-progress>
</template>
<script>
export default {
    props: {
        toDo: {type: Number, default: 0},
        inProgress: {type: Number, default: 0},
        done: {type: Number, default: 0},
        cancelled: {type: Number, default: 0},
        closed: {type: Number, default: 0},
    },
    computed: {
        totalCount() {
            return this.toDo + this.inProgress + this.done + this.cancelled + this.closed;
        }
    },
    name: 'ProgressBar',
    data() {
        return {
            total: 0,
        }
    }
}
</script>
<style scoped>
.project-progress-bar {
    border-radius: 10px;
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 5px grey;
    /* opacity: 0.8; */
}

</style>